export const renderIcon = (clicked: boolean, mode: string) => {
  if (clicked) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.98007 17.9998C8.72007 17.9998 8.49007 17.8998 8.29007 17.7098L4.29007 13.7098C4.10309 13.5229 3.99805 13.2693 3.99805 13.0048C3.99805 12.7404 4.10309 12.4868 4.29007 12.2998C4.47705 12.1129 4.73064 12.0078 4.99507 12.0078C5.25949 12.0078 5.51309 12.1129 5.70007 12.2998L8.99007 15.5898L18.2801 6.29983C18.467 6.11286 18.7206 6.00781 18.9851 6.00781C19.2495 6.00781 19.5031 6.11286 19.6901 6.29983C19.877 6.48681 19.9821 6.74041 19.9821 7.00483C19.9821 7.26926 19.877 7.52286 19.6901 7.70983L9.69007 17.7098C9.49007 17.9098 9.24007 17.9998 8.98007 17.9998Z"
          fill={mode === "dark" ? "#e0eccf" : "#7D808D"}
        />
      </svg>
    )
  } else {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 6C4.45 6 4 6.45 4 7L4 20C4 21.1 4.9 22 6 22H15C15.55 22 16 21.55 16 21C16 20.45 15.55 20 15 20H6L6 7C6 6.45 5.55 6 5 6ZM14.59 2L9.5 2C8.4 2 7.5 2.9 7.5 4L7.5 16.5C7.5 17.6 8.4 18.5 9.5 18.5H18C19.1 18.5 20 17.6 20 16.5V7.41C20 7.14 19.89 6.89 19.71 6.7L15.3 2.29C15.11 2.1 14.86 2 14.59 2ZM18 16.5H9.5L9.5 4L13 4V8C13 8.55 13.45 9 14 9L18 9V16.5Z"
          fill="#7D808D"
        />
      </svg>
    )
  }
}

export const copyToClipboard = async (
  text: string,
  setClicked: (clicked: boolean) => void,
) => {
  try {
    await navigator.clipboard.writeText(text)
    setClicked(true)
  } catch (_err) {
    // console.error("Failed to copy text: ", err)
  }
}
